(() => {
  'use strict';

  const root = document.getElementById('MainContent');
  if (!root || !document.body.classList.contains('product-template')) return;

  const asElement = (node) => {
    if (!node) return null;
    return node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
  };

  const isEditable = (element) => Boolean(element?.closest(
    'input, textarea, select, option, [contenteditable="true"], [data-en-copy-allow]'
  ));

  const isInteractive = (element) => Boolean(element?.closest(
    'a, button, input, textarea, select, option, label, summary, [contenteditable="true"], [data-en-copy-allow], [role="button"], [role="link"], [role="tab"], [role="menuitem"], [role="checkbox"], [role="radio"], [role="switch"], [role="combobox"], [role="slider"], [role="spinbutton"]'
  ));

  document.addEventListener('copy', (event) => {
    const active = asElement(document.activeElement);
    if (isEditable(active)) return;

    const selection = document.getSelection();
    const anchor = asElement(selection?.anchorNode);
    const focus = asElement(selection?.focusNode);
    if ((anchor && root.contains(anchor)) || (focus && root.contains(focus))) {
      event.preventDefault();
    }
  }, true);

  root.addEventListener('contextmenu', (event) => {
    const element = asElement(event.target);
    if (!element) return;

    if (element.closest('img, picture')) {
      event.preventDefault();
      return;
    }

    if (!isInteractive(element)) event.preventDefault();
  }, true);

  root.addEventListener('dragstart', (event) => {
    const element = asElement(event.target);
    if (element?.closest('img, picture')) event.preventDefault();
  }, true);

  root.addEventListener('selectstart', (event) => {
    const element = asElement(event.target);
    if (element && !isEditable(element)) event.preventDefault();
  }, true);
})();
